<!-- Exemplo de uso no final -->
<template>
  <b-modal v-if="url"
           v-model="visible"
           hide-header
           hide-footer
           size="xl">
    <object class="document-preview embed-responsive Recibo_modal"
            :data="url"
            type="application/pdf"
            style="height: 60vh; width: 100%;">
      <p>Seu browser não suporta arquivos pdf diretamente ou este arquivo não existe. Você pode tentar efetuar o download clicando <a :href="url">aqui</a>.</p>
    </object>

    <hr>

    <div class="text-right mt-2">
      <button class="btn btn-sm"
              @click="close">
        Cancelar
      </button>

      <button class="btn btn-sm btn-secondary"
              @click="imprimir">
        Imprimir
      </button>
    </div>
  </b-modal>
</template>

<script>
  export default {
    name: 'ModalImpressao',
    props: {
      url: {
        type: String,
        default: '',
        required: true
      }
    },
    data () {
      return {
        visible: false
      }
    },
    watch: {
      url () {      
        if (this.url && this.url.length) {
          this.visible = true
        }
      },
      visible (novoValor) {
        this.$store.dispatch('impressaoReciboOS/setModalImpressaoEstaFechado', !novoValor)
      }
    },
    methods: {
      close () {
        this.visible = false
        this.$emit('close')
      },
      imprimir () {
        const printWindow = window.open(this.url)
        printWindow.addEventListener('load', () => printWindow.print(), { once: true })
      }
    }
  }
</script>

<style scoped>
.document-preview {
  height: 100%;
  width: 100%;
}
</style>

<!-- <template>
  <div>
    <button @click="showPDF">Mostrar PDF</button>
    <ModalImpressao :url="pdfUrl" @close="handleClose"></ModalImpressao>
  </div>
</template>

<script>
import ModalImpressao from './caminho.vue';

export default {
  components: {
    ModalImpressao
  },
  data() {
    return {
      pdfUrl: ''
    };
  },
  methods: {
    showModalPDF() {
      this.pdfUrl = 'https://example.com/seu-documento.pdf'; // URL do seu PDF
    },
    handleCloseModalPDF() {
      this.pdfUrl = ''; // Limpa a URL ao fechar o modal
    }
  }
};
</script> -->
